module.exports = __webpack_public_path__ + "img/huiyuanquanyi.e8ad07bd.png";